import { useState } from "react";

const useForceUpdate = () => {
  const [trigger, forceUpdate] = useState(0);

  return { trigger, forceUpdate: () => forceUpdate(Date.now()) };
};

export default useForceUpdate;
